import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { NgArcProgressModel } from './ngarc-progress.model';

@Injectable({
  providedIn: 'root'
})
export class NgArcProgressService {

  formPercentageFilledSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  formPercentageFilled$: Observable<any> = this.formPercentageFilledSubject.asObservable();

  formFilledModelSubject: BehaviorSubject<NgArcProgressModel> = new BehaviorSubject<NgArcProgressModel>(null);
  formFilledModel$: Observable<NgArcProgressModel> = this.formFilledModelSubject.asObservable();

  /**
   * @param model
   * Description: updateModelProgress method will update the current percentage of screen that have been filled.
   */
  updateModelProgress(model: NgArcProgressModel) {
    const percentageOfFormFilled = (model.highPageFilled / model.totalPages) * 100;
    this.formPercentageFilledSubject.next(percentageOfFormFilled);
    this.formFilledModelSubject.next(model);
  }
}
